/* eslint no-use-before-define: 0 */

const { $ } = window;

$(document).ready(() => {
    MoveImageUnderTitle();
    $(window).resize(function () {
        MoveImageUnderTitle();
    });
   
    addListeners();
});

function addListeners() {
    const $video = $("#videoBanner");
    if ($video.length) {
        const $button = $("#play-pause-btn");

        $button.on('click', function () {
            
            const $iconPlay = $button.find('.play').first();
            const $iconPause = $button.find('.pause').first();

            const isPlay = $iconPlay.css('display') === 'none';

            
            const videoEl = $video.get(0);

            if (isPlay) {
                $iconPlay.css('display', 'block');
                $iconPause.css('display', 'none');
                videoEl.pause();
            } else {
                $iconPlay.css('display', 'none');
                $iconPause.css('display', 'block');
                videoEl.play();
            }
        });
    }
}


function MoveImageUnderTitle() {
    const $ctabanner = $('.ctabanner');
    if (!$ctabanner.hasClass('full-width') && $ctabanner.hasClass('heading-first')) {
        const $imageArea = $ctabanner.find('.image-area').first();
        const $contentBlock = $ctabanner.find('.content-area');
        const $contentBlockHeader = $ctabanner.find('.content-area h1');

        $imageArea.hide();

        if ($(window).width() < 768) {
            if ($contentBlock.find('.mobile-image').length < 1) {
                const $copiedImage = $imageArea.clone().addClass('mobile-image');
                $contentBlockHeader.after($copiedImage);
                $copiedImage.show();
            }
        } else {
            $contentBlock.find('.mobile-image').remove();
            $imageArea.show();
        }
    }
}
